
<template>
  <div>
    <v-card style="border-radius:12px">
      <v-card-text>
        <v-data-table :headers="headers" :items="items"   class="elevation-1">
          <template v-slot:item.s_name="{item}">
            <div class="text-xs-center title">{{ item.s_name }}</div>
          </template>
          <template v-slot:item.current_accumulated_bags="{item}">
            <div class="text-xs-center title">
              {{ Number(item.current_accumulated_bags).toLocaleString('pt-BR') }}
            </div>
          </template>
          <template v-slot:item.current_accumulated_daily_goal="{item}">
            <div class="text-xs-center title">
              {{Number(item.current_accumulated_daily_goal).toLocaleString('pt-BR')}}
            </div>
          </template>
          <template v-slot:item.last_month_accumulated_daily_goal="{item}">
            <td class="text-xs-center title">
              {{Number(item.last_month_accumulated_daily_goal).toLocaleString('pt-BR')}}
            </td>
          </template>
          <template v-slot:item.last_year_accumulated_daily_goal="{item}">
            <div class="text-xs-center title">
              {{Number(item.last_year_accumulated_daily_goal).toLocaleString('pt-BR')}}
            </div>
          </template>
          <template v-slot:item.current_accumulated_yield="{item}">
            <div :class="['text-xs-center title', (item.current_accumulated_yield) < 0 ? 'red--text' : 'success--text']">
              <v-icon :color="(item.current_accumulated_yield) < 0 ? 'error' : 'success'">
                {{ (item.current_accumulated_yield) >= 0 ? 'mdi-menu-up' : 'mdi-menu-down'}}
              </v-icon>
              {{ (item.current_accumulated_yield).toFixed(2) }}%
            </div>
          </template>
          <template v-slot:item.last_month_accumulated_yield="{item}">
            <div :class="['text-xs-center title', (item.last_month_accumulated_yield) < 0 ? 'red--text' : 'success--text']">
              <v-icon :color="(item.last_month_accumulated_yield) < 0 ? 'error' : 'success'">
                {{ (item.last_month_accumulated_yield) >= 0 ? 'mdi-menu-up' : 'mdi-menu-down'}}
              </v-icon>
              {{ (item.last_month_accumulated_yield).toFixed(2) }}%
            </div>
          </template>
          <template v-slot:item.last_year_accumulated_yield="{item}">
            <div :class="['text-xs-center title', (item.last_year_accumulated_yield) < 0 ? 'red--text' : 'success--text']">
              <v-icon :color="(item.last_year_accumulated_yield) < 0 ? 'error' : 'success'">
                {{ (item.last_year_accumulated_yield) >= 0 ? 'mdi-menu-up' : 'mdi-menu-down'}}
              </v-icon>
              {{ (item.last_year_accumulated_yield).toFixed(2) }}%
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

export default {
  name: 'OneMonthReport',
  props: {
    report: {
      type: Object,
    },
  },
  data() {
    return {
      key: null,
      headers: [
        { text: 'Vendedor', value: 's_name' },
        { text: 'Venda Acumulado', value: 'current_accumulated_bags' },
        { text: 'Meta Acumulado (mês atual)', value: 'current_accumulated_daily_goal' },
        { text: 'Meta Acumulado (mês anterior)', value: 'last_month_accumulated_daily_goal' },
        { text: 'Meta Acumulado (mesmo mês, ano anterior)', value: 'last_year_accumulated_daily_goal' },

        { text: 'Rendimento Acumulado (mês atual)', value: 'current_accumulated_yield' },
        { text: 'Rendimento Acumulado (mês anterior)', value: 'last_month_accumulated_yield' },
        { text: 'Rendimento Acumulado (mesmo mês, ano anterior)', value: 'last_year_accumulated_yield' },
      ],
      items: [
      ],
    }
  },
  mounted() {
    this.items = this.report && this.report.sellers ? [...this.report.sellers] : []
  },
  watch: {
    report(nv, ov) {
      if (nv && nv.sellers) {
        this.items = [...nv.sellers];
      }
    }
  },
}
</script>